import { useQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  GetContractTermsAndConditions,
  GetContractTermsAndConditionsVariables
} from '@/graphql/contracts/_generated_/getContractTermsAndConditions.query';
import GetContractTermsAndConditionsQuery from '@/graphql/contracts/getContractTermsAndConditions.query.gql';
import { notificationService } from '@/services/notification/notification.client';

export default function useGetContractTermsAndConditions(contractId: UUID) {
  const { data, error, loading, refetch } = useQuery<
  GetContractTermsAndConditions,
  GetContractTermsAndConditionsVariables
  >(
    GetContractTermsAndConditionsQuery,
    {
      client: apolloClientContracts,
      fetchPolicy: 'cache-and-network',
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      variables: { contractId }
    }
  );

  return {
    termsAndConditions: data?.contractTermsAndConditions ?? null,
    isLoading: loading,
    error,
    refetch
  } as const;
}
